<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'CREATE_BUSSINESS_USER_PAGE.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'USERS.TITLE' | translate"
        [previousPageUrl]="'/bc-admin'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <mat-card appearance="outlined" class="card-container-wrapper">
      <mat-card-content>
        <app-create-user-form
          #createForm
          [accountGroupId]="accountGroupId$ | async"
          (userCreated)="navigateAfterUserCreation($event)"
        ></app-create-user-form>
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-flat-button
          color="primary"
          data-testid="create-user"
          (click)="createUser()"
          [disabled]="isCreatingUser$$ | async"
        >
          <glxy-button-loading-indicator [isLoading]="(isCreatingUser$$ | async) === true">
            {{ 'CREATE_BUSSINESS_USER_PAGE.CREATE_USER_BUTTON' | translate }}
          </glxy-button-loading-indicator>
        </button>
        <button mat-stroked-button (click)="cancel()" [disabled]="isCreatingUser$$ | async">
          {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </glxy-page-wrapper>
</glxy-page>
